import React from 'react'
import { useTranslation } from 'react-i18next'

const CATS = ['hotel','appartement','maison_meublee','studio','villa', 
  'ForRent','TwoRoom','House','SharedRoom','Parking']

export default function CategoryTabs({ active, onChange }){
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap gap-2">
      <button
        className={`px-3 py-2 rounded-xl border ${active===null?'bg-primary text-white':'bg-white'}`}
        onClick={()=>onChange(null)}
      >
        {t('categories.all')}
      </button>
      {CATS.map(c=>(
        <button
          key={c}
          className={`px-3 py-2 rounded-xl border ${active===c?'bg-primary text-white':'bg-white'}`}
          onClick={()=>onChange(c)}
        >
          {t(`categories.${c}`)}
        </button>
      ))}
    </div>
  )
}
